module.exports = __webpack_public_path__ + "static/img/2.2c3a395.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/2.png
// module id = DOyi
// module chunks = 0